import { useEffect } from 'react'
import styles from './account-wrapper.module.scss'
import NewSiteProductListSection from '@src/quince-site-common/src/organisms/tracking/molecules/newSiteProductListSection'
import SidebarNav from './SidebarNav'
import { useQuinceRouter as useRouter } from '@src/modules/navigation'
import { useSearchParams } from 'next/navigation'
import { getIsNativeViewClient } from '@src/quince-site-common/src/helpers/getIsNativeViewClient'
import useDeviceInfo from '@src/quince-site-common/src/hooks/useDeviceInfo'
import { useAuth } from '@lastbrand/fe-common/universal-auth'
import { getStorage } from '@src/utils/enhancedStorage'
import { Loader } from '@src/quince-components/src'
import { logout } from '../../utils'
import { captureException } from '../Sentry/utils'
import { FEATURES, MODULES } from '@src/quince-site-common/src/constants/template-info'

const AccountWrapper = ({ children, menu, contact, useRedirectionOnly = false }) => {
  const router = useRouter()
  const searchParams = useSearchParams()
  const fromAction = searchParams.get('from')
  const { isNativeView } = useDeviceInfo()
  const { isInitializing, isLoggedIn } = useAuth()

  useEffect(() => {
    if (!isLoggedIn && !getIsNativeViewClient() && !isInitializing) {
      if (fromAction) {
        getStorage().setItem('fromContactAction', fromAction, { isGlobal: true })
      }

      logout()
      router.push(`/log-in?redirecturi=${encodeURIComponent(window.location.href)}`)
    } else if (getIsNativeViewClient() && !isLoggedIn && !isInitializing) {
      try {
        window.ReactNativeWebView.postMessage(
          JSON.stringify({
            action: 'NAVIGATION',
            url: window.location.href,
            newURL: `/log-in`,
            nextURL: `/log-in?redirecturi=${encodeURIComponent(window.location.href)}`,
          }),
        )
      } catch (e) {
        captureException(e, {
          module: MODULES.QUINCE_APP,
          feature: FEATURES.EMIT_REACT_NATIVE_EVENT,
          extraInfo: {
            // @i18n-ignore
            message: 'emitReactNativeEvent failed',
          },
        })
      }
    }
  }, [fromAction, isLoggedIn, isInitializing])

  if (isInitializing || !isLoggedIn) {
    return (
      <div className={styles.loaderWrapper}>
        <Loader showLoader />
      </div>
    )
  }

  if (useRedirectionOnly) {
    return <>{children}</>
  }

  return (
    <>
      <div className={styles.styledAccountWrapper}>
        <div className={styles.container}>
          {!isNativeView && <SidebarNav menuList={menu} contact={contact} />}
          <div className={styles.contentWrapper}>{children}</div>
        </div>
      </div>
      <NewSiteProductListSection />
    </>
  )
}

export default AccountWrapper
